<template>
  <div :id="'mediaCategorySelectContainer'" :class="['form-group', {'has-error': hasFieldErrors(pErrorKey)}]">
    <div v-if="hasFieldErrors(pErrorKey)">
      <span v-for="error in getFieldErrors(pErrorKey)" class="help-block" :key="error">{{ error }}</span>
    </div>
    <label v-else :for="'mediaCategorySelectContainer'">
      <span v-if="pRequired" class="required">*</span> {{ pDictionary['dictionary.media.category']}}:
    </label>
    <select :id="'mediaCategorySelect'"
            :ref="'mediaCategorySelect'"
            :name="pInputName"
            v-model="selectedValues"
            @change="updateValue"
            data-live-search="true"
            :data-container="pSelectContainer || 'false'"
            :data-deselect-all-text="pDictionary['dictionary.actions.select.none']"
            :data-select-all-text="pDictionary['dictionary.actions.select.all']"
            :data-count-selected-text="pDictionary['dictionary.media.category.count']"
            :data-none-selected-text="pDictionary['dictionary.media.category.select.multiple']"
            data-selected-text-format="count > 3"
            data-actions-box="true"
            class="form-control" multiple
            :disabled="disabled">
      <option value="-1">{{pDictionary['dictionary.media.category.all']}}</option>
      <option v-for="mediaCategoryRef in mediaCategoryList"
                :key="mediaCategoryRef.id"
                :value="mediaCategoryRef.id"
              :selected="selectedValues.includes(mediaCategoryRef.id)">
          {{ mediaCategoryRef.name }}
      </option>
    </select>
    <span class="help-block" v-html="pDictionary['dictionary.field.list.multiple.hint']"></span>
  </div>
</template>

<script>
export default {
  name: "MediaCategorySelect",
  model: {
    // By default, `v-model` reacts to the `input`
    // event for updating the value, we change this
    // to `change` for similar behavior as the
    // native `<select>` element.
    event: 'change',
  },
  props: {
    value: [String, Array],
    pCurrencies: Array,
    pLanguage: String,
    pDictionary: Object,
    pUrls: Object,
    pErrorList: {
      type: Object,
      default: function () {
        return {}
      }
    },
    pSrc: String,
    pSrcId: String,
    pErrorKey: String,
    pRequired: Boolean,
    pInputName: String,
    pSelectContainer: {
      default: function () {
        return ""
      }
    },
    pDisabled: Boolean
  },
  data: function () {
    return {
      mediaCategoryList: [],
      selectedValues: this.value
    }
  },
  methods: {
    hasFieldErrors: function (name) {
      if(name in this.pErrorList)
      {
        return !$.isEmptyObject(this.pErrorList[name]);
      }
    },
    getFieldErrors: function (name) {
      if(name in this.pErrorList)
      {
        return this.pErrorList[name];
      }
      return [];
    },
    updateValue: function () {
      // Emitting a `change` event with the new
      // value of the `<select>` field, updates
      // all values bound with `v-model`.
      this.$emit('change', this.selectedValues)
    }
  },
  computed: {
    disabled: function () {
      return this.pDisabled || this.mediaCategoryList.length === 0;
    }
  },
  watch: {
    value: function (value) {
      this.selectedValues = value;
    }
  },
  mounted: function () {
    let _component = this;
    $.ajax({
             type: "POST",
             url: '/mediaplan/app/endpoints/json-api/ref/medias/categories',
             data: JSON.stringify({}),
             headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
             }
           }).done(function (list) {
      _component.mediaCategoryList = list;
    });
  }
}
</script>

<style scoped>

</style>